'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useLocation } from 'react-router-dom';
import ContentViewport from '../../components/ContentViewport';
import LessonCompleteInterstitial from '../../components/ContentInterstitials/LessonCompleteInterstitial';
import { fetchPublicLessons, getRecommendedLessons } from '../../actions/LessonActions';
import RecommendedLessons from '../../components/LessonPage/RecommendedLessons';
import UsageTracker from '../../utils/UsageTracker';
import { SCREENS, SUB_SCREENS } from '../../constants/Tracking';
import { getSelectedLanguageFiltersFromRoute } from '../../selectors/routeSelectors';
import styled, { mediaQuery, css } from '../../utils/Styling';
const MobilePadded = styled.div.withConfig({
  displayName: "RecommendedLessonsContainer__MobilePadded",
  componentId: "zo8bs5-0"
})(["margin-top:24px;padding-left:12px;padding-right:12px;", ""], mediaQuery('notMobile', css(["padding-left:30px;padding-right:30px;"])));

const RecommendedLessonsContainer = ({
  lesson,
  recommendedLessonIds,
  getRecommendedLessons: getRecommendations,
  fetchPublicLessons: fetchLessons,
  hasError,
  isRequesting,
  maxLessons
}) => {
  const location = useLocation();
  const language = getSelectedLanguageFiltersFromRoute({}, {
    location
  });
  useEffect(() => {
    fetchLessons(language.first());
  });
  useEffect(() => {
    if (!recommendedLessonIds.size) {
      getRecommendedLessons(lesson.get('id'));
    }
  }, [lesson, recommendedLessonIds, getRecommendations]);
  useEffect(() => {
    UsageTracker.track('subpageView', {
      screen: SCREENS.LESSON,
      subscreen: SUB_SCREENS.RECOMMENDATIONS,
      lessonId: lesson.get('id')
    });
  }, [lesson]);
  const onClickRecommendedLesson = useCallback(lessonId => {
    UsageTracker.track('interaction', {
      action: 'click-recommendation',
      screen: SCREENS.LESSON,
      subscreen: SUB_SCREENS.RECOMMENDATIONS,
      recommendationSeedId: lesson.get('id'),
      recommendationType: 'LESSON',
      lessonId
    });
  }, [lesson]);

  if (hasError || !isRequesting && recommendedLessonIds.isEmpty()) {
    return /*#__PURE__*/_jsx(ContentViewport, {
      children: /*#__PURE__*/_jsx(LessonCompleteInterstitial, {})
    });
  }

  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(MobilePadded, {
      "data-test-id": "track-recommendations-page",
      children: /*#__PURE__*/_jsx(ContentViewport, {
        children: /*#__PURE__*/_jsx(RecommendedLessons, {
          isRequesting: isRequesting,
          lessonIds: recommendedLessonIds.take(maxLessons),
          lessonName: lesson.get('name'),
          onClickLesson: onClickRecommendedLesson
        })
      })
    })
  });
};

const mapDispatchToProps = {
  getRecommendedLessons,
  fetchPublicLessons
};

function mapStateToProps(state, ownProps) {
  const {
    lessons
  } = state;
  return {
    hasError: lessons.getIn(['recommendedLessons', 'hasError'], false),
    isRequesting: lessons.getIn(['recommendedLessons', 'isRequesting'], false),
    recommendedLessonIds: lessons.getIn(['recommendedLessons', 'bySeedLessonId', ownProps.lesson.get('id')], List())
  };
}

RecommendedLessonsContainer.propTypes = {
  fetchPublicLessons: PropTypes.func.isRequired,
  getRecommendedLessons: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  isRequesting: PropTypes.bool.isRequired,
  lesson: ImmutablePropTypes.map.isRequired,
  maxLessons: PropTypes.number.isRequired,
  recommendedLessonIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired
};
RecommendedLessonsContainer.defaultProps = {
  maxLessons: 3
};
export default connect(mapStateToProps, mapDispatchToProps)(RecommendedLessonsContainer);